import { Info, Copy, Check } from 'lucide-react'
import { useState } from 'react'
import { useStore } from '../hooks/useStore'

export default function SyncBanner() {
    const { userId } = useStore()
    const [copied, setCopied] = useState(false)

    if (!userId) return null

    const personalLink = `${window.location.origin}${window.location.pathname}?id=${userId}`

    const copyLink = () => {
        navigator.clipboard.writeText(personalLink)
        setCopied(true)
        setTimeout(() => setCopied(false), 2000)
    }

    return (
        <div className="bg-primary-50 dark:bg-primary-900/50 border-b border-primary-200 dark:border-primary-800">
            <div className="container mx-auto px-4 py-3 sm:px-6 lg:px-8">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs sm:text-sm">
                    <div className="flex items-center text-primary-700 dark:text-primary-300">
                        <Info className="w-3.5 h-3.5 mr-1.5 flex-shrink-0" />
                        <p>
                            已同步，请**收藏此链接**供多端续写。
                        </p>
                    </div>
                    <div className="flex items-center gap-2 w-full sm:w-auto">
                        <code className="bg-white dark:bg-primary-950 px-2 py-1 rounded border border-primary-200 dark:border-primary-800 truncate flex-1 sm:max-w-xs">
                            {personalLink}
                        </code>
                        <button
                            onClick={copyLink}
                            className="flex items-center gap-1 px-3 py-1 bg-primary-900 dark:bg-white text-white dark:text-primary-900 rounded hover:opacity-90 transition-opacity"
                        >
                            {copied ? (
                                <>
                                    <Check className="w-4 h-4" />
                                    <span>已复制</span>
                                </>
                            ) : (
                                <>
                                    <Copy className="w-4 h-4" />
                                    <span>复制链接</span>
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
